<div class="alert-animation" [ngClass]="{ 'expanded': expanded, 'slide-in': animate, 'slide-out': !animate }">
    @if (animationAlert) {
        <ms-live-alert-item [alert]="animationAlert"></ms-live-alert-item>
    }
</div>
@if (lastAlert) {
    <div class="alert-last" [ngClass]="{ 'expanded': expanded, 'fade-out': animate, 'fade-in': !animate }">
        <ms-live-alert-item [alert]="lastAlert"></ms-live-alert-item>
        @if (hasAlertsForExpand) {
            <span (click)="toggleExpand($event)">
                <vn-icon class="arrow" size="12" [name]="expanded ? 'theme-up' : 'theme-down'"></vn-icon>
            </span>
        }
    </div>
}
@if (expanded && hasAlertsForExpand) {
    <ng-scrollbar class="alert-list ng-scrollbar-compact" [viewportPropagateMouseMove]="false" (click)="$event.stopPropagation()">
        @for (alert of alerts | slice: 1; track alert.eventId) {
            <ms-live-alert-item [alert]="alert"> </ms-live-alert-item>
        }
    </ng-scrollbar>
}
